<template>
  <div
    class="authenticated"
    :class="{ 'is-app': isApp, 'side-menu-open': isSideMenuOpen }"
    :style="appStyle"
  >
    <app-header v-if="showHeader" />
    <side-menu />
    <router-view />
    <app-footer v-if="showFooter" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AppHeader from '@/components/header/AppHeader'
import AppFooter from '@/components/footer/AppFooter'
import SideMenu from '@/components/sideMenu/SideMenu'

export default {
  components: {
    AppHeader,
    AppFooter,
    SideMenu,
  },
  computed: {
    ...mapGetters({
      isSideMenuOpen: 'setting/getIsSideMenuOpen',
      seatNo: 'seat/getSeatNo',
    }),
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
    showHeader() {
      return this.hasSeatNo && !this.isSearchPage && !this.isSelfcheckPage
    },
    showFooter() {
      return this.hasSeatNo && !this.isSelfcheckPage
    },
    hasSeatNo() {
      return this.seatNo !== null
    },
    isSearchPage() {
      return this.$route.path === '/search'
    },
    isSelfcheckPage() {
      return this.$route.path.includes('selfcheck')
    },
    appStyle() {
      return {
        paddingTop: this.showHeader ? '55px' : undefined,
        paddingBottom: this.showFooter ? '50px' : undefined,
      }
    },
  },
  methods: {
    ...mapActions({
      setAuth: 'auth/setAuth',
    }),
  },
}
</script>
<style lang="scss" scoped>
.authenticated {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  max-width: 100vw;
  height: 100%;

  &.side-menu-open {
    overflow: hidden;
  }

  &.is-app {
    height: 100vh;
  }
}
</style>
